export const ACCOUNTS_MIGRATION_TOGGLED_ACCOUNTS_KEY = 'ACCOUNTS_MIGRATION_TOGGLED_ACCOUNTS_KEY';
export const ACCOUNTS_MIGRATION_PENDING_ACCOUNTS_POST_IMPORT_KEY =
    'ACCOUNTS_MIGRATION_PENDING_ACCOUNTS_POST_IMPORT_KEY';
export const ACCOUNTS_MIGRATION_SUCCESFULLY_IMPORTED_ACCOUNT_KEY =
    'ACCOUNTS_MIGRATION_SUCCESFULLY_IMPORTED_ACCOUNT_KEY';
export const ACCOUNTS_MIGRATION_UNALLOWED_PROVIDER_HINTS_KEY =
    'ACCOUNTS_MIGRATION_ACCOUNTS_NOT_IMPORTED_KEY';
export const ACCOUNTS_MIGRATION_UNALLOWED_ACCOUNT_TYPES_KEY =
    'ACCOUNTS_MIGRATION_UNALLOWED_ACCOUNT_TYPES_KEY';
